/* ==========================================================================
   DUNEKS — theme.js
   Sin dependencias. Módulos:
   1. Utilidades y formato de dinero     6. Carrito AJAX + panel lateral
   2. Paneles laterales (drawers)        7. Tarjetas: muestras y añadir rápido
   3. Encabezado y barra de anuncios     8. Filtros de colección (AJAX)
   4. Buscador predictivo                9. Página de producto (variantes + galería)
   5. Carruseles y videos               10. Recomendaciones, footer, varios
   ========================================================================== */
(() => {
  'use strict';

  const T = window.theme || { routes: {}, strings: {} };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const escapeHtml = (str = '') => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- 1. Formato de dinero (respeta el formato de tu tienda, ej. COP sin decimales) ---------- */
  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const withDelimiters = (n, precision = 2, thousands = ',', decimal = '.') => {
      const [whole, frac] = (n / 100).toFixed(precision).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    const match = format.match(placeholder);
    const key = match ? match[1] : 'amount';
    let value;
    switch (key) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  window.formatMoney = formatMoney;

  const toastEl = $('[data-toast]');
  let toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  }

  /* ---------- 2. Paneles laterales ---------- */
  let lastFocus = null;
  function openDrawer(name) {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return false;
    closeSearch();
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
    const focusable = d.querySelector('.drawer__panel button, .drawer__panel a, .drawer__panel input');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 60);
    return true;
  }
  function closeDrawers() {
    const open = $$('[data-drawer].is-open');
    if (!open.length) return;
    open.forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (openDrawer(opener.dataset.drawerOpen)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) closeDrawers();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeDrawers(); closeSearch(); }
  });

  /* ---------- 3. Encabezado y anuncios ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  $$('[data-announcement]').forEach((bar) => {
    const slides = $$('.announcement__slide', bar);
    let i = 0;
    if (slides.length > 1) {
      setInterval(() => {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, parseInt(bar.dataset.speed, 10) || 4000);
    }
    const cd = $('[data-countdown]', bar);
    if (cd) {
      const end = new Date(cd.dataset.countdown).getTime();
      if (isNaN(end)) { cd.parentElement.hidden = true; return; }
      const tick = () => {
        let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const d = Math.floor(s / 86400); s %= 86400;
        const h = Math.floor(s / 3600); s %= 3600;
        const m = Math.floor(s / 60); s %= 60;
        const p2 = (n) => String(n).padStart(2, '0');
        cd.textContent = `${p2(d)}d : ${p2(h)}h : ${p2(m)}m : ${p2(s)}s`;
      };
      tick();
      setInterval(tick, 1000);
    }
  });

  /* ---------- 4. Buscador predictivo ---------- */
  const searchOverlay = $('[data-search-overlay]');
  const searchInput = $('[data-predictive-input]');
  const searchResults = $('[data-predictive-results]');
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    setTimeout(() => searchInput && searchInput.focus(), 80);
  }
  function closeSearch() {
    if (!searchOverlay || !searchOverlay.classList.contains('is-open')) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-search-close]')) closeSearch();
  });

  if (searchInput && searchResults && T.predictiveSearch !== false) {
    let controller;
    const run = debounce(async () => {
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const url = `${T.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: controller.signal });
        const data = await res.json();
        renderPredictive(q, (data.resources && data.resources.results) || {});
      } catch (err) {
        if (err.name !== 'AbortError') searchResults.innerHTML = '';
      }
    }, 220);
    searchInput.addEventListener('input', run);
  }

  function renderPredictive(q, r) {
    const products = r.products || [];
    const queries = r.queries || [];
    const collections = r.collections || [];
    const searchUrl = `${T.routes.search}?q=${encodeURIComponent(q)}&options[prefix]=last`;
    if (!products.length && !queries.length && !collections.length) {
      searchResults.innerHTML = `<p>${T.strings.noResults} “${escapeHtml(q)}”.</p>`;
      return;
    }
    const terms = queries.concat(collections).slice(0, 8).map((item) => {
      const label = item.styled_text || escapeHtml(item.title || item.text);
      return `<li><a href="${item.url}">${label}</a></li>`;
    }).join('');
    const prods = products.map((p) => {
      const img = (p.featured_image && p.featured_image.url) || p.image;
      const imgUrl = img ? img + (img.includes('?') ? '&' : '?') + 'width=400' : '';
      const cents = Math.round(parseFloat(p.price) * 100);
      return `<a href="${p.url}" class="predictive__product">
        <div class="predictive__product-img">${imgUrl ? `<img src="${imgUrl}" alt="${escapeHtml(p.title)}" loading="lazy" width="400" height="400">` : ''}</div>
        <span class="predictive__product-title">${escapeHtml(p.title)}</span>
        <span class="price"><span class="price__now">${formatMoney(cents)}</span></span>
      </a>`;
    }).join('');
    searchResults.innerHTML = `<div class="predictive">
      <div>${terms ? `<p class="predictive__label">${T.strings.suggestions}</p><ul class="predictive__terms">${terms}</ul>` : ''}</div>
      <div>${prods ? `<p class="predictive__label">${T.strings.products}</p><div class="predictive__products">${prods}</div>` : ''}
        <a class="link-underline predictive__all" href="${searchUrl}">${T.strings.viewAll}</a>
      </div>
    </div>`;
  }

  /* ---------- 5. Carruseles y videos ---------- */
  function initCarousel(c) {
    if (c.dataset.ready) return;
    c.dataset.ready = '1';
    const track = $('[data-carousel-track]', c);
    const prev = $('[data-carousel-prev]', c);
    const next = $('[data-carousel-next]', c);
    if (!track) return;
    const step = () => {
      const first = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const w = first ? first.getBoundingClientRect().width + gap : 300;
      return Math.max(w, Math.floor(track.clientWidth / w) * w);
    };
    const update = () => {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    // Puntos de paginación (como el referente)
    let dotsWrap = null;
    if (c.hasAttribute('data-carousel-dots')) {
      dotsWrap = document.createElement('div');
      dotsWrap.className = 'carousel__dots';
      c.appendChild(dotsWrap);
    }
    const renderDots = () => {
      if (!dotsWrap) return;
      const pages = Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth));
      const current = Math.min(pages - 1, Math.round(track.scrollLeft / track.clientWidth));
      if (dotsWrap.children.length !== pages) {
        dotsWrap.innerHTML = Array.from({ length: pages }, (_, i) => `<button type="button" aria-label="Página ${i + 1}" data-page="${i}"></button>`).join('');
      }
      Array.from(dotsWrap.children).forEach((d, i) => d.classList.toggle('is-active', i === current));
      dotsWrap.hidden = pages < 2;
    };
    if (dotsWrap) dotsWrap.addEventListener('click', (e) => {
      const b = e.target.closest('[data-page]');
      if (b) track.scrollTo({ left: parseInt(b.dataset.page, 10) * track.clientWidth, behavior: 'smooth' });
    });
    track.addEventListener('scroll', debounce(renderDots, 60), { passive: true });
    window.addEventListener('resize', debounce(renderDots, 150));
    renderDots();
    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  }
  $$('[data-carousel]').forEach(initCarousel);

  // Los videos de fondo solo se reproducen cuando están en pantalla (ahorra datos y batería).
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initAutoplayVideos(scope = document) {
    const vids = $$('[data-autoplay-video] video', scope);
    if (!vids.length) return;
    vids.forEach((v) => { v.muted = true; v.playsInline = true; if (reduceMotion) v.removeAttribute('autoplay'); });
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) { const p = target.play(); if (p) p.catch(() => {}); }
        else target.pause();
      });
    }, { threshold: 0.15 });
    vids.forEach((v) => io.observe(v));
  }
  initAutoplayVideos();

  /* ---------- 6. Carrito ---------- */
  const Cart = {
    async get() {
      const r = await fetch(`${T.routes.cart}.js`, { headers: { Accept: 'application/json' } });
      return r.json();
    },
    async add(items) {
      const r = await fetch(`${T.routes.cart_add}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || T.strings.error);
      return d;
    },
    async change(key, quantity) {
      const r = await fetch(`${T.routes.cart_change}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || T.strings.error);
      return d;
    }
  };
  window.DuneksCart = Cart;

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const wrap = $('[data-cart-items]');
    if (!wrap) return;

    if (!cart.items.length) {
      wrap.innerHTML = `<div class="cart-empty"><p>${T.strings.cartEmpty}</p><a class="btn btn--primary" href="${T.routes.all}">${T.strings.continueShopping}</a></div>`;
    } else {
      wrap.innerHTML = cart.items.map((item) => {
        const img = item.image
          ? `<img src="${item.image}${item.image.includes('?') ? '&' : '?'}width=240" alt="${escapeHtml(item.product_title)}" loading="lazy" width="120" height="120">`
          : '';
        const opts = !item.product_has_only_default_variant && item.options_with_values
          ? item.options_with_values.map((o) => `<span>${escapeHtml(o.name)}: ${escapeHtml(o.value)}</span>`).join('')
          : '';
        const was = item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : '';
        return `<div class="cart-item" data-key="${item.key}">
          <a href="${item.url}" class="cart-item__media">${img}</a>
          <div class="cart-item__info">
            <a href="${item.url}" class="cart-item__title">${escapeHtml(item.product_title)}</a>
            <div class="cart-item__opts">${opts}</div>
            <div class="cart-item__price">${was}<span>${formatMoney(item.final_line_price)}</span></div>
            <div class="cart-item__row">
              <div class="qty qty--sm">
                <button type="button" data-qty-change="-1" aria-label="Menos">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-qty-change="1" aria-label="Más">+</button>
              </div>
              <button type="button" class="cart-item__remove" data-qty-remove>${T.strings.remove}</button>
            </div>
          </div>
        </div>`;
      }).join('');
    }

    const sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);

    const bar = $('[data-ship-bar]');
    if (bar) {
      const threshold = parseInt(bar.dataset.threshold, 10) || 0;
      const left = threshold - cart.total_price;
      $('[data-ship-fill]', bar).style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
      $('[data-ship-text]', bar).innerHTML = left > 0
        ? T.strings.shipLeft.replace('[amount]', `<strong>${formatMoney(left)}</strong>`)
        : T.strings.shipDone;
      bar.hidden = !cart.items.length;
    }
    const foot = $('.cart-drawer__foot');
    if (foot) foot.hidden = !cart.items.length;
  }

  // Pintado inicial del carrito lateral
  const cartJson = $('[data-cart-json]');
  if (cartJson) {
    try { renderCart(JSON.parse(cartJson.textContent)); } catch (e) { Cart.get().then(renderCart); }
  }

  async function addToCart(id, quantity = 1, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    try {
      await Cart.add([{ id: Number(id), quantity }]);
      const cart = await Cart.get();
      renderCart(cart);
      if (T.cartType === 'drawer' && openDrawer('cart')) return;
      if (T.cartType === 'drawer') toast(T.strings.added);
      else window.location.href = T.routes.cart;
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
    }
  }
  window.DuneksAddToCart = addToCart;

  // Cambiar cantidades / eliminar (carrito lateral y página de carrito)
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-qty-change], [data-qty-remove]');
    if (!b) return;
    const row = b.closest('[data-key]');
    if (!row) return;
    const current = parseInt((row.querySelector('.qty span') || {}).textContent || '1', 10);
    const qty = b.hasAttribute('data-qty-remove') ? 0 : Math.max(0, current + parseInt(b.dataset.qtyChange, 10));
    row.classList.add('is-loading');
    try {
      const cart = await Cart.change(row.dataset.key, qty);
      if (row.closest('[data-cart-page]')) { window.location.reload(); return; }
      renderCart(cart);
    } catch (err) {
      toast(err.message);
      row.classList.remove('is-loading');
    }
  });

  // Formularios de producto → carrito AJAX
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || T.cartType !== 'drawer') return;
    e.preventDefault();
    const id = form.querySelector('[name="id"]').value;
    const qtyInput = document.querySelector(`[name="quantity"][form="${form.id}"]`) || form.querySelector('[name="quantity"]');
    const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    addToCart(id, qty, form.querySelector('[type="submit"]'));
  });

  // Botones +/- de cantidad en producto
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
  });

  /* ---------- 7. Tarjetas: muestras de color y añadir rápido ---------- */
  function selectSwatch(s) {
    const card = s.closest('[data-product-card]');
    if (!card) return;
    $$('[data-card-swatch]', card).forEach((x) => x.classList.toggle('is-active', x === s));
    const img = $('.card__img--primary', card);
    if (img && s.dataset.image) {
      img.removeAttribute('srcset');
      img.src = s.dataset.image;
    }
    if (s.dataset.variantId) card.dataset.variantId = s.dataset.variantId;
    if (s.dataset.url) $$('[data-card-link]', card).forEach((a) => { a.href = s.dataset.url; });
    const qa = $('[data-quick-add]', card);
    if (qa) {
      const available = s.dataset.available !== 'false';
      qa.disabled = !available;
      const label = $('[data-quick-text]', qa);
      if (label) label.textContent = available ? T.strings.add : T.strings.soldOut;
    }
  }
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-card-swatch]');
    if (s) { e.preventDefault(); selectSwatch(s); return; }
    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      const card = qa.closest('[data-product-card]');
      addToCart(card.dataset.variantId, 1, qa);
    }
  });
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', (e) => {
      const s = e.target.closest('[data-card-swatch]');
      if (s && !s.classList.contains('is-active')) selectSwatch(s);
    });
  }

  /* ---------- 8. Filtros de colección (sin recargar la página) ---------- */
  const coll = $('[data-collection]');
  if (coll) {
    const sectionId = coll.dataset.sectionId;
    const swap = ['[data-toolbar]', '[data-active-filters]', '[data-collection-results]', '[data-filter-body]'];

    const update = async (url) => {
      coll.classList.add('is-loading');
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      try {
        const html = await (await fetch(u.toString())).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        swap.forEach((sel) => {
          const fresh = $(sel, doc);
          const old = $(sel, coll);
          if (fresh && old) old.replaceWith(fresh);
        });
        u.searchParams.delete('section_id');
        history.replaceState({}, '', u.pathname + u.search);
      } catch (err) {
        window.location.href = url;
      } finally {
        coll.classList.remove('is-loading');
      }
    };

    const fromForm = (form) => {
      const params = new URLSearchParams();
      for (const [k, v] of new FormData(form)) if (v !== '') params.append(k, v);
      return `${window.location.pathname}?${params.toString()}`;
    };

    const onChange = debounce((form) => update(fromForm(form)), 350);
    coll.addEventListener('change', (e) => {
      const form = e.target.form;
      if (form && form.matches('[data-filter-form]')) onChange(form);
    });
    coll.addEventListener('input', (e) => {
      if (e.target.type === 'number' && e.target.form && e.target.form.matches('[data-filter-form]')) onChange(e.target.form);
    });
    coll.addEventListener('submit', (e) => {
      if (e.target.matches('[data-filter-form]')) { e.preventDefault(); update(fromForm(e.target)); }
    });
    coll.addEventListener('click', (e) => {
      const a = e.target.closest('[data-filter-link]');
      if (a) { e.preventDefault(); update(a.href); }
    });
  }

  /* ---------- 9. Página de producto ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    let inventory = {};
    try { inventory = JSON.parse(($('[data-inventory-json]', root) || {}).textContent || '{}'); } catch (e) { inventory = {}; }
    const lowStock = parseInt(root.dataset.lowStock, 10) || 0;
    const colorIndex = parseInt(root.dataset.colorIndex, 10);
    const filterByColor = root.dataset.filterMedia === 'true' && colorIndex >= 0;
    const form = $('form[data-product-form]', root);
    const idInput = form && form.querySelector('[name="id"]');
    const fieldsets = $$('fieldset[data-option-index]', root);
    const stage = $('[data-gallery-stage]', root);
    const allSlides = stage ? Array.from(stage.children) : [];
    const colorNames = colorIndex >= 0
      ? [...new Set(product.variants.map((v) => String(v.options[colorIndex]).toLowerCase().trim()))]
      : [];

    const selectedOptions = () => fieldsets.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    const visibleSlides = () => allSlides.filter((s) => !s.hidden);
    const isGrid = () => stage && getComputedStyle(stage).display === 'grid';

    /* Galería */
    function setActive(id) {
      $$('[data-thumb]', root).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
      $$('[data-dot]', root).forEach((d) => d.classList.toggle('is-active', d.dataset.dot === String(id)));
      $$('.gallery__slide video', root).forEach((v) => {
        const slide = v.closest('[data-media-id]');
        if (!isGrid() && slide && slide.dataset.mediaId !== String(id) && !v.paused) v.pause();
      });
    }
    function goToMedia(id, smooth = true) {
      if (!stage) return;
      const slide = $(`[data-media-id="${id}"]`, stage);
      if (!slide || slide.hidden) return;
      if (!isGrid()) stage.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(id);
    }
    function currentIndex() {
      const vis = visibleSlides();
      const i = Math.round(stage.scrollLeft / (stage.clientWidth || 1));
      return Math.max(0, Math.min(vis.length - 1, i));
    }
    // Muestra solo las fotos cuyo texto alternativo coincide con el color elegido (+ las fotos sin color)
    function filterMedia(color) {
      if (!filterByColor || !stage) return;
      const key = String(color || '').toLowerCase().trim();
      const matches = allSlides.filter((s) => s.dataset.mediaAlt === key);
      const show = (alt) => !matches.length || alt === key || !colorNames.includes(alt);
      allSlides.forEach((s) => { s.hidden = !show(s.dataset.mediaAlt); });
      allSlides.forEach((s) => s.classList.remove('is-lead'));
      const lead = visibleSlides()[0];
      if (lead) lead.classList.add('is-lead');
      $$('[data-thumb], [data-dot]', root).forEach((el) => { el.hidden = !show(el.dataset.mediaAlt); });
      root.classList.toggle('gallery-single', visibleSlides().length < 2);
      stage.scrollTo({ left: 0 });
      const first = visibleSlides()[0];
      if (first) setActive(first.dataset.mediaId);
    }

    if (stage) {
      $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => goToMedia(t.dataset.thumb)));
      stage.addEventListener('scroll', debounce(() => {
        if (isGrid()) return;
        const s = visibleSlides()[currentIndex()];
        if (s) setActive(s.dataset.mediaId);
      }, 80), { passive: true });
      const step = (dir) => {
        const vis = visibleSlides();
        const s = vis[Math.max(0, Math.min(vis.length - 1, currentIndex() + dir))];
        if (s) goToMedia(s.dataset.mediaId);
      };
      const prev = $('[data-gallery-prev]', root);
      const next = $('[data-gallery-next]', root);
      prev && prev.addEventListener('click', () => step(-1));
      next && next.addEventListener('click', () => step(1));
    }

    if ($('model-viewer', root) && window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => {} }]);
    }

    /* Variantes */
    function updateAvailability(opts) {
      fieldsets.forEach((fs, i) => {
        $$('input', fs).forEach((input) => {
          const ok = product.variants.some((v) => v.available && v.options[i] === input.value &&
            v.options.every((o, j) => j === i || opts[j] == null || o === opts[j]));
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-soldout', !ok);
        });
      });
    }
    function priceHtml(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const off = Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
        const offText = (T.priceOffFormat || '-[percent]%').replace('[percent]', off);
        return `<s class="price__was">${formatMoney(v.compare_at_price)}</s><span class="price__now">${formatMoney(v.price)}</span><span class="price__off">${escapeHtml(offText)}</span>`;
      }
      return `<span class="price__now">${formatMoney(v.price)}</span>`;
    }
    function updateBadges(v) {
      const qty = inventory[v.id];
      const low = lowStock > 0 && v.available && typeof qty === 'number' && qty > 0 && qty <= lowStock;
      $$('[data-badge-low]', root).forEach((b) => { b.hidden = !low; });
      $$('[data-badge-soldout]', root).forEach((b) => { b.hidden = v.available; });
    }
    function updateInstallments(v) {
      $$('[data-installments]', root).forEach((el) => {
        const n = parseInt(el.dataset.installments, 10) || 4;
        const txt = $('[data-installments-text]', el);
        if (txt) txt.textContent = el.dataset.template.replace('[count]', n).replace('[amount]', formatMoney(Math.floor(v.price / n)));
      });
    }

    const radioVariant = () => {
      const r = root.querySelector('[data-variant-radio]:checked');
      return r ? product.variants.find((v) => String(v.id) === r.value) : null;
    };
    function onVariantChange() {
      const picked = radioVariant();
      const opts = picked ? picked.options.slice() : selectedOptions();
      fieldsets.forEach((fs) => {
        const lbl = $('[data-option-value]', fs);
        const c = fs.querySelector('input:checked');
        if (lbl && c) lbl.textContent = c.value;
      });
      if (fieldsets.length) updateAvailability(opts);
      const variant = picked || product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      const gl = $('[data-grouped-picker] > .vlabel [data-option-value]', root);
      if (gl && variant) gl.textContent = colorIndex >= 0 ? variant.options[colorIndex] : variant.title;
      const btn = $('[data-add-button]', root);
      const btnText = $('[data-add-text]', root);
      const sticky = $('[data-sticky-button]', root);
      const waitlist = $('[data-waitlist]', root);
      if (colorIndex >= 0) filterMedia(opts[colorIndex]);

      if (!variant) {
        if (btn) btn.disabled = true;
        if (sticky) sticky.disabled = true;
        if (btnText) btnText.textContent = T.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (btn) btn.disabled = !variant.available;
      if (sticky) sticky.disabled = !variant.available;
      if (btnText) btnText.textContent = variant.available ? (btn.dataset.label || btnText.textContent) : T.strings.soldOut;
      if (waitlist) waitlist.hidden = variant.available;

      $$('.product__price [data-price], .product__mobile-head [data-price]', root).forEach((price) => {
        price.innerHTML = priceHtml(variant);
        price.classList.toggle('price--sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
      });
      const sp = $('[data-sticky-price]', root);
      if (sp) sp.textContent = formatMoney(variant.price);
      const sku = $('[data-sku]', root);
      if (sku) sku.textContent = variant.sku || '';
      updateBadges(variant);
      updateInstallments(variant);

      if (variant.featured_media) goToMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
      root.dispatchEvent(new CustomEvent('variant:change', { detail: variant, bubbles: true }));
    }

    const addBtn = $('[data-add-button]', root);
    const addText = $('[data-add-text]', root);
    if (addBtn && addText && !addBtn.disabled) addBtn.dataset.label = addText.textContent.trim();
    else if (addBtn) addBtn.dataset.label = T.strings.addToCart;

    root.addEventListener('change', (e) => {
      if (e.target.closest('fieldset[data-option-index]') || e.target.matches('[data-variant-radio]')) onVariantChange();
    });

    // Estado inicial
    const v0 = radioVariant();
    const opts0 = v0 ? v0.options : selectedOptions();
    if (fieldsets.length) updateAvailability(opts0);
    if (colorIndex >= 0) filterMedia(opts0[colorIndex]);
    const featured = root.dataset.featuredMedia;
    if (featured) goToMedia(featured, false);

    // Barra fija de compra en móvil: aparece cuando el botón principal sale de pantalla
    const stickyBar = $('[data-sticky-atc]', root);
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      stickyBar.hidden = false;
      new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', passed);
      }).observe(addBtn);
    }
  }
  $$('[data-product]').forEach(initProduct);

  /* ---------- 10. Recomendaciones, footer y varios ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (!el.dataset.url || el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        $$('[data-carousel]', el).forEach(initCarousel);
      }
    } catch (e) { /* sin recomendaciones */ }
  });

  document.addEventListener('click', (e) => {
    const h = e.target.closest('[data-footer-col] .footer__heading');
    if (!h || window.matchMedia('(min-width: 990px)').matches) return;
    const col = h.closest('[data-footer-col]');
    col.classList.toggle('is-open');
    h.setAttribute('aria-expanded', col.classList.contains('is-open'));
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  // Compatibilidad con el editor de temas: reinicializa al editar secciones
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-carousel]', e.target).forEach(initCarousel);
    $$('[data-product]', e.target).forEach(initProduct);
    initAutoplayVideos(e.target);
  });
})();
